import { io } from "socket.io-client";

// Shared upstream price feed: one socket per browser tab, fed by the
// backend's single Binance connection (src/price/price.gateway.ts) instead
// of every component polling api.binance.com directly every 5s.
let socket;
const prices = {}; // { ETHUSDT: { symbol, price, priceChangePercent }, ... }
const listeners = new Set();

const notify = () => listeners.forEach((cb) => cb(prices));

const connectPriceSocket = () => {
    if (socket) return socket;

    socket = io(`${import.meta.env.VITE_API_BASE_URL}/prices`, {
        transports: ["websocket", "polling"],
    });

    socket.on("price_snapshot", (ticks) => {
        ticks.forEach((tick) => { prices[tick.symbol] = tick; });
        notify();
    });

    socket.on("price_update", (tick) => {
        prices[tick.symbol] = tick;
        notify();
    });

    // Without this, a failed connection (e.g. the backend not having this
    // gateway loaded) leaves the price display permanently blank with
    // nothing in the console to explain why.
    socket.on("connect_error", (err) => {
        console.warn("[priceSocket] connection error:", err.message);
    });

    return socket;
};

// Subscribes to live price updates; callback fires immediately with
// whatever's cached, then again on every change. Returns an unsubscribe fn.
export const subscribeToPrices = (callback) => {
    connectPriceSocket();
    listeners.add(callback);
    callback(prices);
    return () => listeners.delete(callback);
};
